export default __webpack_public_path__ + "static/media/T740_A_BD.b79d2945.pdf";